<template>
  <div class="v_box">
    <div class="b_banxin1">
        <div class="v_boxlist" v-html="icp">

        </div>

        <div class="v_boxlist txtnowarp">

        	<a class="v_boxlist" target="_blank" href="http://www.beian.miit.gov.cn">陕ICP备14008812号</a>

        </div>
    </div>
  </div>
</template>
<script>
  import qs from "qs";
    export default {
        data() {
            return {
                list: [{
                    listname: '© 2005-2019 51文具网-我要文具网 版权所有，并保留所有权利。'
                }, {
                    listname: '51文具网电子服务平台 Tel: 400 002 5187 E-mail: woyaowenju@foxmail.com'
                }, {
                    listname: '陕ICP备14008812号'
                }],
              icp:'',//信息

            }
        },
      created() {
        let that = this;

        // if(that.$storage.get('user_data') != null) {
        //   that.shopData['userrole'] = that.$storage.get('user_data').rank_id
        // } else {
        //   that.shopData['userrole'] = 1
        // }

        // that.guanggaoFn();
        that.getnewall();


        // that.getFriend();
      },
      methods:{
        getnewall() {
          let that = this;
          axios({
            method: "post",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
            },
            url: that.$publicUrl.http1 + that.$publicUrl.searchlist,
            data: qs.stringify({})
          })
            .then(function(response) {
              let data = response.data;
              if (data.stateCode == 10000) {
                that.icp = data.data.icp
              } else {
                that.$message({
                  message: data.msg,
                  type: "warning"
                });
              }
            })
            .catch(function(error) {});
        },
      }

    }
</script>
<style scoped>
    .v_box {
        background-color: #000000;
        width: 100%;
        box-sizing: border-box;
        padding: 20px 0;
    }

    .v_boxlist {
        width: 100%;
        text-align: center;
        line-height: 30px;
        font-size: 16px;
        color: #ffffff;
    }
</style>
